
import Vue from "vue"

type Theme = "primary" | "secondary" | "danger" | "success"

export default Vue.extend({
  props: {
    theme: {
      type: String as VuePropType<Theme>,
      default: "primary",
    },
    to: { type: [String, Object], default: "" },
    href: { type: String, default: "" },
    isLoading: { type: Boolean, default: false },
  },

  computed: {
    is () {
      if (this.to) return "nuxt-link"
      if (this.href) return "a"
      return "button"
    },
  },
})
